var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-deactivated-filial"},[_c('font-awesome-icon',{attrs:{"icon":"times"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }